import React, { useEffect, useState } from 'react';
import { Alert } from '@components/Alert';
import Button from '@components/Button';
import styles from './Updates.module.scss';
import { CircledArrowIcon } from '@repo/icons';
import { appVersion } from '@app/config';
import { apiRequest } from '@repo/utils/helpers/api';

export default function Updates() {
  const [state, setState] = useState<{
    version: null | string;
    open: boolean;
  }>({
    version: appVersion,
    open: false,
  });

  useEffect(() => {
    let mounted = true;
    const handleFocus = () => {
      // FIXME figure out how to handle version.json check locally
      if (window.getEnv() === 'development') {
        return;
      }
      apiRequest<{
        version: string;
      }>('GET', '/version.json', undefined, {
        noAuthorization: true,
        isFullPath: true,
      }).then(({ version }) => {
        if (!mounted) {
          return;
        }
        const { version: existingVersion } = state;

        if (existingVersion === version) {
          return;
        }

        window.__updateAvailable = true;

        setState({
          version,
          open: true,
        });
      });
    };

    window.app.on('window:focus', handleFocus);

    return () => {
      mounted = false;
      window.app.off('window:focus', handleFocus);
    };
  }, []);

  function handleRefresh() {
    window.location.reload();
  }

  if (!state.open) {
    return null;
  }

  return (
    <Button className={styles.container} onClick={handleRefresh}>
      <Alert className={styles.alert}>
        App Update Available
        <CircledArrowIcon transform="rotate(-90)" color="textSecondary" />
      </Alert>
    </Button>
  );
}
